import { CvApi } from "../services/cv-api";
import { Section } from "@/types/section";

export interface SectionsState {
  sections: Section[];
}

const state: SectionsState = {
  sections: []
};

const mutations = {
  setSections(state: SectionsState, sections: Section[]) {
    state.sections = sections;
  }
};
const getters = {
  sections: (state: SectionsState): Section[] => state.sections
};

const actions = {
  fetchSections({ commit, state }: { commit: any; state: SectionsState }) {
    if (Object.keys(state.sections).length == 0) {
      const sections = CvApi.getSections();
      // Sort sections
      sections.sort((a, b) => a.order - b.order);
      // Sort rows in all sections
      sections.forEach(s => s.rows.sort((a, b) => a.order - b.order));
      commit("setSections", sections);
    }
  }
};

export const sections = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
